/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentAuthorisationDataSchema = z.object({
	paymentIntentId: z.string(),
	status: z.string(),
	clientSecret: z.string().nullable(),
})

export type PaymentAuthorisationDataSchema = z.infer<typeof paymentAuthorisationDataSchema>
